import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import App from './app'
import { i18nInitPromise } from './infrastructure/i18nextHelper'
import './infrastructure/extensions'
import 'chartjs-adapter-moment'
import annotationPlugin from 'chartjs-plugin-annotation'
import { Chart, CategoryScale, PointElement, LineElement, LinearScale, TimeSeriesScale, Legend, Filler, Tooltip } from 'chart.js'
import { GuidedTour } from './infrastructure/guidedTour/guidedTour'
import { StylesProvider } from '@mui/styles'
import { StyledEngineProvider, ThemeProvider } from '@mui/material'
import { theme } from './infrastructure/materialUiThemeProvider'

Chart.register(TimeSeriesScale, CategoryScale, LinearScale, PointElement, LineElement, Legend, Filler, Tooltip, annotationPlugin)

i18nInitPromise.then(() => {
    const container = document.getElementById('appContainer')
    if (!container) throw new Error('Failed to find the root element')
    const root = createRoot(container)

    root.render(
        <Suspense fallback="loading">
            <StyledEngineProvider injectFirst>
                <StylesProvider>
                    <ThemeProvider theme={theme}>
                        <GuidedTour>
                            <App />
                        </GuidedTour>
                    </ThemeProvider>
                </StylesProvider>
            </StyledEngineProvider>
        </Suspense>
    )
}).catch(error => {
    console.error('Failed to initialize i18n:', error)
})